import { render, staticRenderFns } from "./FooterLinks.vue?vue&type=template&id=0380c7d6&scoped=true&lang=pug&"
import script from "./FooterLinks.vue?vue&type=script&lang=ts&"
export * from "./FooterLinks.vue?vue&type=script&lang=ts&"
import style0 from "./FooterLinks.vue?vue&type=style&index=0&id=0380c7d6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0380c7d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
